export default function getCmsDataNew(input: Record<string, unknown>[]): any {
  let cmsData = {};
  const rawObject: any = input;

  if (cmsData) {
    for (const key in rawObject) {
      if (rawObject[key]?.type === 'Link') {
        for (const key1 in rawObject[key].target.fields) {
          if (rawObject[key].target.fields[key1].type !== 'Link') {
            cmsData = {
              ...cmsData,
              [`${key}_${key1}`]: rawObject[key].target.fields[key1].value
            };
          }
        }
      } else {
        cmsData = { ...cmsData, [key]: rawObject[key].value };
      }
    }
  }

  return cmsData;
}
